import ReactDom from "react-dom"

import { CareersList } from "./careers-list"

export default function careersListingReact(el: HTMLElement) {
  ReactDom.render(<CareersList />, el)
}
